export const data = [
    {
        route:"/",
        pt:"Sobre Mim",
        eng:"About me"
    },

    {
        route:"/work",
        pt:"Projetos",
        eng:"My Work"
    },

    {
        route:"/experience",
        pt:"Experiencia",
        eng:"Experience"
    },

    {
        route:"/education",
        pt:"Educação",
        eng:"Education"
    },

    {
        route:"/contacts",
        pt:"Contactos",
        eng:"Contact me"
    },

]